import store from '../store'
import api from '../../api'
import {getUserInfos} from "@/utils/userInfos";

let status = 0 // 0=关闭，1=正常，2=正常重连
let connectNum = 0
const maxConnectNum = 5

const state = {
    ws: null,
    message: {}
}

const mutations = {
    SET_WS(state, ws) {
        state.ws = ws
    },
    SET_MESSAGE(state, msg) {
        state.message = msg
    },
    CLOSE_WS(state) {
        if (state.ws && state.ws.readyState === 1) {
            state.ws.close()
        }
        state.ws = null
    }
}

const actions = {
    connect({commit, dispatch, rootGetters}, user) {
        return new Promise((resolve, reject) => {
            const im_socket_url = rootGetters.app;

            if (status === 1) {
                resolve()
            } else if (!im_socket_url) {
                reject(new Error('获取websocket地址失败'))
            } else if (connectNum >= maxConnectNum) {
                reject(new Error('无法链接websocket服务器, 请刷新页面重试！'))
            } else {
                const ws = new WebSocket(im_socket_url)
                ws.addEventListener('open', e => {
                    status = 1
                    process.env.NODE_ENV !== 'production' && console.log('链接websocket', e)
                })
                ws.addEventListener('message', e => {
                    try {
                        const data = JSON.parse(e.data)

                        if (data.type === 'init') {
                            // 提交后台保存CLIENT_ID
                            let params = {
                                servername: 'Ruyi_AdminSystemServices',
                                method: 'saveUserClientID',
                                params: {client_id: data.client_id}
                            };
                            api.service(params).then(res => {
                                if (res.data.code != 0) {
                                    console.log(res.data.msg);
                                }
                            })

                            // 绑定uid
                            let login_id = getUserInfos().id
                            ws.send(JSON.stringify({"type": "bindUid", "obj_id": login_id, "client_id": data.client_id}))
                        } else if (data.type != 'ping') {
                            commit('SET_MESSAGE', data)
                        }
                    } catch (e) {
                        // 数据异常
                    }
                })
                ws.addEventListener('error', e => {
                    if (status === 1) {
                        status = 2
                        connectNum++
                        dispatch('connect')
                    }
                })
                ws.addEventListener('close', e => {
                    if (status === 1) {
                        status = 2
                        connectNum++
                        dispatch('connect')
                    }

                    let params = {
                        servername: 'Ruyi_AdminSystemServices',
                        method: 'deleteUserClientID'
                    };

                    api.service(params).then(res => {
                        if (res.code != 0) {
                            console.log(res.msg);
                        }
                    })
                    process.env.NODE_ENV !== 'production' && console.log('关闭websocket', e)
                })
                commit('SET_WS', ws)
                resolve()
            }
        })
    },
    close({commit}) {
        status = 0
        connectNum = 0
        commit('CLOSE_WS')
    }
}

export default {
    namespaced: true,
    state,
    mutations,
    actions
}
